module.exports = __webpack_public_path__ + "static/media/K_CarAnimationRED.6778d0d6.gif";